<div class="guest_details" fxLayout="column" fxLayoutAlign="start center">
  <div class="guest_details_header" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center">
    <div class="custom-icon" [style.background-color]="iconColor">
      {{ getInitial() }}
    </div>
    <div class="guest_name">{{selectedGuest?.lastName}}, {{selectedGuest?.firstName}}</div>
  </div>
  <div
      class="guest_details_body width_100"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      *ngFor="let line of lines">
    <div
        class="guest_details_label"
        fxFlex="50"
        fxLayout="row"
        fxLayoutAlign="start center">
      {{line.name}}
    </div>
    <div class="guest_details_value" fxFlex="50" fxLayout="row" fxLayoutAlign="start center">
      {{(selectedGuest && selectedGuest[line.method]) | dynamicPipe: line.pipes}}
    </div>
  </div>
</div>
